<template>
  <div>
    <h1 class="text-2xl mb-6">
      Données mensuelles par source pour Gsc / Wysistat
    </h1>

    <v-row class="ma-3 justify-center">
      <div class="d-flex align-center">
        <v-btn-toggle v-model="isGsc" mandatory class="mb-4">
          <v-btn :value="true" depressed :color="isGsc ? 'primary' : ''"
            >Gsc</v-btn
          >
          <v-btn :value="false" depressed :color="!isGsc ? 'primary' : ''"
            >Wysistat</v-btn
          >
        </v-btn-toggle>
      </div>
    </v-row>

    <div v-if="isGsc">
      <gsc-monthly-filter></gsc-monthly-filter>
      <gsc-monthly-table></gsc-monthly-table>
    </div>
    <div v-else>
      <gsc-monthly-filter></gsc-monthly-filter>
      <wysistat-monthly-table></wysistat-monthly-table>
    </div>
  </div>
</template>
<script>
import useAxios from "@/hooks/useAxios";
import { saveRmraView } from "@/utils/rmr-analytics";
import GscMonthlyFilter from "@/components/audience/gsc-monthly/filters/GscMonthlyFilter.vue";
import gscMonthlyTable from "@/components/audience/gsc-monthly/tables/gscMonthlyTable.vue";
import wysistatMonthlyTable from "@/components/audience/gsc-monthly/tables/wysistatMonthlyTable.vue";

export default {
  name: "GscMonthly",
  components: { GscMonthlyFilter, gscMonthlyTable, wysistatMonthlyTable },
  data() {
    return {
      isGsc: true,
    };
  },
  setup() {
    const { isLoading } = useAxios();

    return {
      isLoading,
    };
  },
  mounted() {
    saveRmraView(this.$route);
  },
  methods: {},
  computed: {},
  watch: {},
};
</script>

<style scoped></style>
